import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SettingsCard from '../../organisms/SettingsCard';
import { FormInput, FormInputWithButton, FormSelect, FormTextarea } from '../../molecules/FormField';
import ToggleField from '../../molecules/ToggleField';
import RoleMultiSelect from '../../molecules/RoleMultiSelect';
import Stepper from '../../organisms/Stepper';
import { SETTINGS_STEPS } from '../../../data/settingsSteps';
import { DEMO_CATEGORY_TYPES } from '../../../data/settingsSteps';
import {
  createComplaintType,
  fetchComplaintTypeById,
  updateComplaintType,
} from '../../../redux/complaintType/actions';

import { setId } from '../../../redux/appDetails/reducer';

const initialFormData = {
  categoryName: '',
  tatMinutes: '',
  template: '',
  categoryType: '',
  description: '',
  visibilityType: '',
  urlLink: '',
  active: true,
  roles: [],
};

const COMPLAINT_TYPE_ACCESS_OPTIONS = [
  { value: 'INTERNAL_LOGIN', label: 'Internal Login' },
  { value: 'PRIVATE_LINK', label: 'Private Link' },
  { value: 'PUBLIC_LINK', label: 'Public Link' },
];

export default function CategoryTypeStep({ stepMeta, stepperProps, pageProps }) {
  // Keep form values in this component so the form data stays on this page.
  // This is easier to understand than saving it in a separate shared context.
  const [formData, setFormData] = useState(initialFormData);

  const dispatch = useDispatch();
  const { id } = useSelector((state) => state.appDetails || {});
  const {  isEdit } = useSelector((state) => state.appDetails || {});
  const complaintTypeState = useSelector((state) => state.complaintType || {});
  const { saving, loading, error } = complaintTypeState;

useEffect(() => {
  console.log('🔥 useEffect:', {
    id,
    isEdit,
  });

  if (!isEdit || id === null || id === undefined) {
    console.log('❌ Not fetching');
    return;
  }

  console.log('🚀 Fetching complaint type:', id);

  dispatch(fetchComplaintTypeById(id))
    .unwrap()
    .then((response) => {
      console.log('✅ API response for ID', id, ':', response);

      const data = response?.data ?? response;

      console.log('📦 Data:', data);

      if (!data) return;

      setFormData({
        categoryName: data.name ?? data.code ?? '',
        tatMinutes: data.tatMinutes ?? '',
        template: data.categoryType ?? '',
        categoryType: data.categoryType ?? '',
        description: data.description ?? '',
        visibilityType: data.visibilityType ?? data.accessType ?? '',
        urlLink: data.urlLink ?? '',
        active: data.isActive ?? data.active ?? true,
        roles: data?.accesses?.map((access) => access?.role?.id) ?? data.roleIds ?? [],
      });
    })
    .catch((error) => {
      console.log('❌ Fetch error:', error);
    });
}, [dispatch, id, isEdit]);

  const RolesList = (pageProps?.rolelist || []).map((role) => ({
    value: role.id,
    label: role.name,
  }));



  const updateField = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const onSubmit = async () => {
    // This is the payload we want to send to the backend.
    // We build it from the local form state, not from a global store.
    const payload = {
      categoryName: formData.categoryName,
      categoryType: formData.categoryType || formData.template,
      tatMinutes: formData.tatMinutes ? Number(formData.tatMinutes) : 0,
      description: formData.description,
      visibilityType: formData.visibilityType,
      urlLink: formData.urlLink,
      active: formData.active,
      roles: formData.roles,
    };

    console.log('CategoryTypeStep payload:', payload);
    console.log("isedit ", isEdit, "id", id);

    const request = isEdit
      ? updateComplaintType({
          id,
          data: {
            code: payload.categoryName,
            name: payload.categoryName,
            description: payload.description,
            tatMinutes: payload.tatMinutes,
            isActive: payload.active,
            accessType: payload.visibilityType,
            roleIds: payload.roles.map((role) => parseInt(role, 10)),
          },
          onSuccess: (data) => {
            console.log('updateComplaintType onSuccess:', data);
            stepperProps.onNext?.();
          },
          onFail: (error) => {
            console.log('updateComplaintType onFail:', error);
          },
        })
      : createComplaintType({ payload , onSuccess: (data) => {
        console.log('createComplaintType onSuccess........................:', data);

        // setId(data?.data?.id ?? data?.id ?? null);
        console.log("data response on creationg ", data);
        dispatch(setId(data?.data?.id ?? data?.id ?? null));
        console.log(id, "system id set up successfully ..........", data?.data?.id ?? data?.id ?? null)
        stepperProps.onNext?.();
      }, onFail: (error) => {
        console.log('createComplaintType onFail:', error);
      }});

    const resultAction = dispatch(request);

    // Only move to next step if API call succeeded.
    if (
      (isEdit && updateComplaintType.fulfilled.match(resultAction)) ||
      (!isEdit && createComplaintType.fulfilled.match(resultAction))
    ) {
      if (!isEdit) {
        const createdId = resultAction.payload?.data?.id ?? resultAction.payload?.id;
        if (createdId !== null && createdId !== undefined) {
          console.log("setting up  system id ..........", createdId)
          dispatch(setId(createdId));
      
          console.log("system id set up successfully ..........", createdId)
        }
      }
      stepperProps.onNext?.();
    }
  };

  return (
    <>
      <Stepper
        {...stepperProps}
        steps={SETTINGS_STEPS}
        showNextButton={Boolean(stepperProps.showNextButton)}
        onNext={onSubmit}
      />
      <SettingsCard
        title={stepMeta.title}
        description={stepMeta.description}
        showNext={false}
      >
        <div className="ca-category-type__status">
          <ToggleField
            checked={formData.active}
            onChange={(active) => updateField('active', active)}
          />
        </div>

        <div className="ca-step-section">
          <div className="ca-step-row ca-step-row--category-fields">
            <FormInput
              label="Category Name"
              className="ca-step-row__grow"
              value={formData.categoryName}
              onChange={(e) => updateField('categoryName', e.target.value)}
              placeholder="Enter category name"
            />

            <FormInputWithButton
              label="TAT Minutes"
              suffix="minutes"
              type="number"
              min="0"
              value={formData.tatMinutes}
              onChange={(e) => updateField('tatMinutes', e.target.value)}
              placeholder="Enter here"
            />
          </div>

          <div className="ca-step-row">
            <FormSelect
              label="Select Template"
              className="ca-step-row__grow"
              value={formData.template || formData.categoryType}
              onChange={(e) => {
                const value = e.target.value;
                updateField('template', value);
                updateField('categoryType', value);
              }}
              options={DEMO_CATEGORY_TYPES}
              placeholder="Select template"
            />
          </div>

          <div className="ca-step-section">
            <FormTextarea
              label="Description"
              placeholder="Enter description"
              maxLength={500}
              value={formData.description}
              onChange={(e) => updateField('description', e.target.value)}
              rows={5}
            />
          </div>

          <div className="ca-step-row">
            <FormSelect
              label="Select Visibility Type"
              className="ca-step-row__grow"
              value={formData.visibilityType}
              onChange={(e) => updateField('visibilityType', e.target.value)}
              options={COMPLAINT_TYPE_ACCESS_OPTIONS}
              placeholder="Select visibility type"
            />

            <FormInput
              label={null}
              className="ca-step-row__grow ca-category-type__url-link"
              value={formData.urlLink}
              onChange={(e) => updateField('urlLink', e.target.value)}
              placeholder="urllink"
            />
          </div>
        </div>

        <div className="ca-step-section ca-step-section--last">
          <RoleMultiSelect
            label="Select Roles for Complaint Filling"
            options={RolesList}
            value={formData.roles}
            onChange={(roles) => updateField('roles', roles)}
          />
        </div>

        {error ? <div className="ca-form-error">{error}</div> : null}
        {loading ? <div className="ca-form-loading">Loading category...</div> : null}
        {saving ? <div className="ca-form-loading">Saving category...</div> : null}
      </SettingsCard>
    </>
  );
}
